import authentification from './authentification/api'
import commande from './commande/api'
import familles from './familles/api'
import files from './files/api'
import incident from './incident/api'
import localisation from './localisation/api'
import locatairePermanent from './locatairePermanent/api'
import manifestation from './manifestation/api'
import edl from './edl/api'
import site from './site/api'
import societe from './societe/api'
import users from './users/api'
import notifification from './notification/api'
import plan from './plan/api'
import roles from './roles/api'
import quartz from './quartz/api'
import controle from './controle/api'
import help from './help/api'
import contacts from './contacts/api'

const api = {
  authentification,
  commande,
  familles,
  files,
  incident,
  localisation,
  locatairePermanent,
  manifestation,
  notifification,
  edl,
  site,
  societe,
  users,
  plan,
  roles,
  quartz,
  controle,
  help,
  contacts,
}

export default api
